export function getSharedJobImplementationId(packageName: string, name: string, version: number, optionalValue: string | null = null) {
    const PRIME = 131;

    // Validate inputs
    if (!packageName || packageName.length === 0) {
        throw new Error("Argument [packageName] cannot be null or empty.");
    }
    if (!name || name.length === 0) {
        throw new Error("Argument [name] cannot be null or empty.");
    }
    if (!Number.isInteger(version) || version < 0) {
        throw new Error("Argument [version] must be a non-negative integer.");
    }

    // Build path from packageName and name
    const path = packageName.split(".");
    path.push(name);

    const endIndex = path.length - 1;
    let id = 0;

    // Iterate over path pieces
    for (let i = 0; i <= endIndex; i++) {
        const piece = path[i];
        if (piece == null || piece.length === 0) {
            throw new Error("Argument [path] cannot contain null or empty pieces.");
        }
        for (let j = 0; j < piece.length; j++) {
            id = (PRIME * id + piece.charCodeAt(j)) | 0;
        }
    }

    // Optional value logic
    if (optionalValue != null) {
        for (let i = 0; i < optionalValue.length - 1; i++) {
            id = (PRIME * id + optionalValue.charCodeAt(i)) | 0;
        }
    }

    // Version logic (minorVersion is always 0)
    id = (PRIME * id + version) | 0;  // majorVersion
    id = (PRIME * id + 0) | 0;        // minorVersion

    return id;
}